import React from "react";

const ScamsCheckHistoryEmpty = () => {
  return (
    <div className="mx-auto max-w-5xl"> 
      
      {/* Container chính: Bo góc, đổ bóng nhẹ, viền mỏng */}
      <div className="bg-white rounded-xl shadow-sm border border-gray-100 overflow-hidden">
        
        {/* HEADER: Giữ nguyên header xịn xò có đèn nháy */}
        <div className="bg-slate-50/50 px-4 py-3 border-b border-gray-100 flex justify-between items-center">
            <h3 className="font-medium text-sm text-slate-600 flex items-center gap-2">
                {/* Hiệu ứng đèn xanh nhấp nháy bằng CSS thuần */}
                <span className="relative flex h-2 w-2">
                    <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-emerald-400 opacity-75"></span>
                    <span className="relative inline-flex rounded-full h-2 w-2 bg-emerald-500"></span>
                </span>
                System Operations Log
            </h3>
            <span className="text-[10px] uppercase tracking-wider text-emerald-600 font-medium bg-emerald-50 px-2 py-0.5 rounded-full border border-emerald-100">
                ● Live Monitoring
            </span>
        </div>

        {/* BODY: Phần hiển thị trạng thái trống */}
        <div className="flex flex-col items-center justify-center py-12 px-4">
            
            {/* Thay Icon Lucide bằng Emoji 📡 (Vệ tinh/Radar) */}
            <div className="h-16 w-16 bg-slate-50 rounded-full flex items-center justify-center mb-4 border border-slate-100 text-3xl grayscale opacity-70">
                📡
            </div>

            {/* Thông báo chính */}
            <h4 className="text-slate-700 font-medium text-sm mb-1">
                No Active Data Tasks
            </h4>

            {/* Mô tả phụ: Dùng thuật ngữ kỹ thuật */}
            <p className="text-slate-400 text-xs text-center max-w-md">
                System operation queue is currently empty. Waiting for new data ingestion triggers or user requests.
            </p>

            {/* Các chỉ số giả lập trạng thái nghỉ */}
            <div className="mt-6 flex gap-2">
                <span className="px-3 py-1.5 rounded-md bg-slate-50 border border-slate-100 text-[10px] text-slate-400 font-mono">
                    Status: IDLE 💤
                </span>
                <span className="px-3 py-1.5 rounded-md bg-slate-50 border border-slate-100 text-[10px] text-slate-400 font-mono">
                    Load: 0% 📉
                </span>
            </div>
        </div>

        {/* FOOTER */}
        <div className="px-4 py-2 bg-gray-50/30 text-center text-[10px] text-gray-400 border-t border-gray-100">
            * Real-time automated system monitoring & audit logs.
        </div>
      </div>
    </div>
  );
};

export default ScamsCheckHistoryEmpty;